/* eslint-disable @typescript-eslint/no-unsafe-call */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM } from '@oneaudi/unified-web-common';
import React from 'react';

export interface WindowSize {
  height: number | string;
  width: number | string;
}
export function changeWindowSize(callbackFunc: any) {
  callbackFunc({ width: window.innerWidth, height: window.innerHeight });
}

export function useWindowSize(): WindowSize {
  const isSSR = typeof window === 'undefined';
  const [windowSize, setWindowSize] = React.useState({
    width: isSSR ? +SYS_BREAKPOINT_SM : window.innerWidth,
    height: isSSR ? +SYS_BREAKPOINT_MD : window.innerHeight,
  });

  React.useEffect(() => {
    window.addEventListener('resize', () => {
      changeWindowSize(setWindowSize);
    });

    return () => {
      window.removeEventListener('resize', () => {
        changeWindowSize(setWindowSize);
      });
    };
  }, []);

  return windowSize;
}
